import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import i48 from "../Images/48.png";
import { Button } from "react-bootstrap";

const Popup = () => {
  useEffect(() => {
    //3 seconds ON
    const showPopup = setTimeout(() => {
      document.getElementById("popup-container").style.display = "block";
    }, 4000);

    //7 seconds OFF
    const closePopup = setTimeout(() => {
      document.getElementById("popup-container").style.display = "none";
    }, 16000);

    return () => {
      clearTimeout(showPopup);
      clearTimeout(closePopup);
    };
  }, []);

  return (
    <div id="popup-container">
      <span
        id="close-btn"
        onClick={() => {
          document.getElementById("popup-container").style.display = "none";
        }}
      >
        <i className="fa-solid fa-circle-xmark text-secondary"></i>
      </span>

      {/* <Link to={`/news-details/mibs2025`}>
        <img
          src="https://ayg.s3.us-east-2.amazonaws.com/MIBS_1+(1).png"
          alt="hcbyachts@AYG"
          className="img-fluid"
        />
      </Link> */}

      <div
        class="card m-0 border-0 shadow-sm"
        style={{
          maxWidth: "840px",
        }}
      >
        <Link to={`/charter`}>
          <div class="row g-0 p-2">
            <div class="col-lg-6">
              <img
                src="https://ayg.s3.us-east-2.amazonaws.com/WhatsApp+Image+2025-04-30+at+11.13.02+AM.jpeg"
                class="img-fluid rounded-start"
                alt="..."
              />
            </div>
            <div class="col-lg-6">
              <div class="card-body">
                <h5 class="card-title text-uppercase">
                  Explore Our Luxury Yacht for Charters
                </h5>
                <Button variant="warning">Explore Now</Button>
                <Link to={`/charter`}></Link>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Popup;
